import { render, staticRenderFns } from "./VxCollapseItem.vue?vue&type=template&id=0c8c14a7&scoped=true"
import script from "./VxCollapseItem.vue?vue&type=script&lang=js"
export * from "./VxCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./VxCollapseItem.vue?vue&type=style&index=0&id=0c8c14a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c14a7",
  null
  
)

export default component.exports